import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {formatDate} from '@/dayjs'
import {ProjectSmall} from '@/features/projects/types'
import {assistiveRegimeToRehabCareCommitment, projectSectorToLabel, projectTypeToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'

export const MedicalReportProjectCard = ({project}: {project: ProjectSmall}) => {
    const {t} = useTranslation()
    const startDate = project.startDate ?? ''
    const expirationDate = project.expirationDate ?? ''

    return (
        <FormCardSection columns={3} gap={2} padding={3}>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:project_details_start_date')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {formatDate(startDate, 'DD/MM/YYYY')}
                </Text>
            </GridItem>

            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:expiration')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {formatDate(expirationDate, 'DD/MM/YYYY')}
                </Text>
            </GridItem>

            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:project_duration')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {project.durationDays}
                </Text>
            </GridItem>

            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:project_type')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {project.type ? t(projectTypeToLabel[project.type]) : '-'}
                </Text>
            </GridItem>

            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:intervention_mode')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {t(projectSectorToLabel[project.sector])}
                </Text>
            </GridItem>

            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:project_details_sub_assistance')}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {project.sector == 'domiciliary'
                        ? t('projects:not_applicable')
                        : project.assistiveRegime
                          ? t('commons:duration_minutes', {
                                value: assistiveRegimeToRehabCareCommitment[project.assistiveRegime]
                            })
                          : '-'}
                </Text>
            </GridItem>
        </FormCardSection>
    )
}
